import { AppThunk } from 'redux/reducers/rootReducer';
import { IGenericDataFetchParams, createGenericDataFetch } from '../generic/GenericDataActions';
import { IDeliveryLine } from 'types/backend_models/deliveries/IDeliveryLine';
import { setFetchDeliverylinesByDeliveryIdPending, setFetchDeliverylinesByDeliveryIdSucces, setFetchDeliverylinesByDeliveryIdError } from 'redux/reducers/data_action_reducers/deliveries/DeliveryLinesByDeliveryIdReducer';

var fetchParams: IGenericDataFetchParams<IDeliveryLine[]> = {
	apiEndPoint: '',
	pendingActionCreator: setFetchDeliverylinesByDeliveryIdPending,
	succesActionCreator: setFetchDeliverylinesByDeliveryIdSucces,
	errorActionCreator: setFetchDeliverylinesByDeliveryIdError
}

export function fetchDeliveryLinesByDeliveryId(deliveryId: number): AppThunk
{
	fetchParams.apiEndPoint = `customer/deliveries/${deliveryId}/lines`;
	return createGenericDataFetch<IDeliveryLine[]>(fetchParams);
}